export enum Role {
    Admin = 'isAdmin',
    Learner = 'isLearner',
    Trainer = 'isTrainer',
    Client = 'isClient',
    Mp = 'isMp',
    Staff = 'isStaff',
    IQA = "isIQA",
    incidentUser = 'isIncidentUser',
    Operative = 'isOperative',
    AssetManager = 'isAssetManager',
    Manager = 'isManager'
}

export enum accidentRole {
    Witness = "isWitness",
    Reporters = "isReporters",
    InvestigationOfficer = 'isInvestigationOfficer'

}